module.exports = __webpack_public_path__ + "media/club_deals/strategies_horizontal_card2-73ffebaf.webp";